'use client';

import React from 'react';
import { Chip, Link } from '@heroui/react';
import { RevshareTransaction } from '../types';
import { useTranslations } from '../../../../contexts/translation.context';
import Typography from '../../../../components/typography/Typography';

interface UserTransactionCellProps {
  transaction: RevshareTransaction;
}

const UserTransactionCell: React.FC<UserTransactionCellProps> = ({ transaction }) => {
  const { t } = useTranslations();
  const { subscriber, transaction_type } = transaction;

  const getTransactionTypeLabel = (type: string): string => {
    const typeMap: Record<string, string> = {
      tips: t('partner.revshare.transactions.transactionTypes.tips') || 'Tips',
      subscription:
        t('partner.revshare.transactions.transactionTypes.subscription') || 'Subscription',
      message: t('partner.revshare.transactions.transactionTypes.messages') || 'Messages',
      messages: t('partner.revshare.transactions.transactionTypes.messages') || 'Messages',
      chat_messages:
        t('partner.revshare.transactions.transactionTypes.chatMessages') || 'Chat Messages',
      post: t('partner.revshare.transactions.transactionTypes.posts') || 'Posts',
      posts: t('partner.revshare.transactions.transactionTypes.posts') || 'Posts',
      stream: t('partner.revshare.transactions.transactionTypes.stream') || 'Stream',
    };
    return typeMap[type] || type;
  };

  const userName = subscriber?.name || subscriber?.username || 'Unknown';
  const username = subscriber?.username || '';

  return (
    <div className="flex flex-col gap-1">
      {/* Row 1: User name with link */}
      <div className="flex items-center gap-1">
        <Typography variant="body2" className="!font-semibold !text-auth-ink">
          {userName}
        </Typography>
        {username && (
          <Link
            href={`https://onlyfans.com/${username}`}
            target="_blank"
            className="flex items-center"
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.5 1H2.2C1.53726 1 1 1.53726 1 2.2V9.8C1 10.4627 1.53726 11 2.2 11H9.8C10.4627 11 11 10.4627 11 9.8V8.5M7 1H11M11 1V5M11 1L5 7"
                stroke="#006FEE"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        )}
      </div>
      {/* Row 2: Transaction type chip */}
      <Chip
        size="sm"
        classNames={{
          base: 'bg-[#EEEEEF] h-6 px-2 w-fit',
          content: 'text-auth-muted text-xs font-normal p-0',
        }}
      >
        {getTransactionTypeLabel(transaction_type)}
      </Chip>
    </div>
  );
};

export default UserTransactionCell;
